import React, { useState, useEffect, useRef } from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import globalJson from '../../../data/global';
import ClientLogo from '../../App/ClientLogo/ClientLogo';
import VideoPlayer from '../../App/VideoPlayer/VideoPlayer';
import classes from './SponsoredVideos.module.scss';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import ShareButtonSocials from 'components/App/ShareButtonSocials/ShareButtonSocials.js'
import MediaQuery from 'react-responsive';

const sponsoredVideoThumbnails = require.context('../../../images/components/SponsoredVideos/thumbnails', true, /.*\.(gif|png|jpe?g|svg)$/i);
const sponsoredVideoPosters = require.context('../../../images/components/SponsoredVideos/videoposters', true, /.*\.(gif|png|jpe?g|svg)$/i);
const sponsoredVideoPlayingIcon = require.context('../../../images/components/SponsoredVideos', true, /.*\.(gif|png|jpe?g|svg)$/i);

function trackingArrowLeft(event){
	window.gtag('event', "carousel clicked arrow left", {
		'event_category': globalJson.tracking.ga_category,
		'event_label': "carousel clicked arrow left",
		'value':10
	});
}

function trackingArrowRight(event){
	window.gtag('event', "carousel clicked arrow right", {
		'event_category': globalJson.tracking.ga_category,
		'event_label': "carousel clicked arrow right",
		'value':10
	});
}

function trackingEpisodeClicked(event){
	window.gtag('event', "carousel video clicked", {
		'event_category': globalJson.tracking.ga_category,
		'event_label': "carousel video clicked "+ event,
		'value':10
	});
}

function SponsoredVideos(props){

	const [episodeSelection, setEpisodeSelection] = useState(0);
	const [currentSegment, setCurrentSegment] = useState(0);
	const [carouselSizeState, setCarouselSizeState] = useState({
		visibleSlides:4
	})
	const [shareVideoMarkup, setShareVideoMarkup] = useState("")
	const [shareVideoMarkupDesk, setShareVideoMarkupDesk] = useState("")
	const [videoPlayerMarkup, setVideoPlayerMarkup] = useState("")
	const [videoPlayerInfoMarkup, setVideoPlayerInfoMarkup] = useState("")
	const [totalSlideSegments, setTotalSlideSegments] = useState(Math.ceil((props.content.videoList.length)/carouselSizeState.visibleSlides))

	let autoPlayVideo = useRef(false)
	let carouselProgressBar = useRef()
	let carouselProviderRef = useRef()
	let socialID = props.content.socialId;


	let videoChoices = props.content.videoList.map((item, index) => 
		<Slide key={index} index={index} onClick={() => onEpisodeClick(item, index)} className={classes.pure_react_carousel__slider_inner}>
			<div className={`${classes.sponsored_video__slide_content_container} ${(episodeSelection === index ? classes['sponsored_video__slide_content_container--selected'] : "")}`}>
				<div className={classes.sponsored_video__slide_content_image_div}>
					<img className={classes.sponsored_video__slide_content_image} src={getFileName(sponsoredVideoThumbnails, item.thumbnailImage)} alt={item.imageTitle}></img>
					<div className={classes.sponsored_video__slide_content_hover}></div>
				</div>
			
				<div className={classes.sponsored_video__slide_content_title}>
					{episodeSelection === index ? <div className={classes.sponsored_video__slide_content_now_playing}>
								<h3>Now Playing</h3>
								<img className={classes['sponsored_video__slide__content_icon_playing']} src={getFileName(sponsoredVideoPlayingIcon, 'icon_playing.svg')} alt="now playing"/>
							</div>
						: <span>{item.title} </span>
					}
					{/* <span>{(episodeSelection === index ? "Now Playing" : item.title)}</span> */}
				</div>
			</div>
		</Slide>
	)

	let globalImages = props.globalImages;

	function onEpisodeClick(item, index){
		if(index !== episodeSelection){
			setVideoPlayerMarkup("")
			autoPlayVideo.current = true
			setEpisodeSelection(index)
		}
		trackingEpisodeClicked(item.title);
	}

	function onVideoComplete(){

	}

	useEffect(() => {
		let chosenEpisodeData = props.content.videoList[episodeSelection]
		setTimeout(function(){

			setVideoPlayerMarkup(<VideoPlayer 
				onComplete={() => onVideoComplete()} 
				content={props.content.videoList[episodeSelection].video} 
				videoImages={sponsoredVideoPosters} 
				windowSize={props.windowSize} 
				autoPlay={autoPlayVideo.current}/>
			)
		}
		, 500)

		setVideoPlayerInfoMarkup(

			<div className={`col-md-5`}>
				<h3 className={classes.sponsored_video__container_title}>{chosenEpisodeData.title}</h3>
				<p className={classes.sponsored_video__container_desc}>{chosenEpisodeData.bodyCopy}</p>
				{/* <MediaQuery minWidth={classes.screenMd}>
					<p>{props.content.shareMessage}<BlueSocialIcon url={chosenEpisodeData.social.url} description={chosenEpisodeData.social.message}></BlueSocialIcon></p>
				</MediaQuery> */}
			</div>

		)
		setShareVideoMarkup(
			// <MediaQuery maxWidth={classes.screenMdMax}>
			// 	<div className={`col-md-5`}>
			// 		<p>{props.content.shareMessage}<BlueSocialIcon url={chosenEpisodeData.social.url} description={chosenEpisodeData.social.message}></BlueSocialIcon></p>
			// 	</div>
			// </MediaQuery>
		)

		setShareVideoMarkupDesk(
			<MediaQuery minWidth={classes.screenMd}>
				<div className={classes.sponsored_video__share_desk_container}>
					<p className={classes.sponsored_video__share_desk}>
						<span className={classes.sponsored_video__share_desk_title}>{props.content.shareMessage}</span>
						{/* <BlueSocialIcon url={chosenEpisodeData.social.url} 
							description={chosenEpisodeData.social.message}>
						</BlueSocialIcon> */}
						
					</p>
					<div className={`sponsor-videos`}>
					<ShareButtonSocials url={chosenEpisodeData.social.url} 
							description={chosenEpisodeData.social.message}
							socialID={socialID}></ShareButtonSocials>

				</div>
				</div>
			</MediaQuery>
		)

	},[episodeSelection])

	function updateWindowSize(){
		switch (props.windowSize) {
			case "tablet":
				setCarouselSizeState({
					visibleSlides:3,
					naturalSlideWidth:300,
					naturalSlideHeight:250
				})
				break;
			case "desktop":
					setCarouselSizeState({
						visibleSlides:4,
						naturalSlideWidth:300,
						naturalSlideHeight:200
					})
				break
			default:
					setCarouselSizeState({
						visibleSlides:1,
						naturalSlideWidth:50,
						naturalSlideHeight:30
					})
				break;
		}
	}

	useEffect(() =>{
		updateWindowSize()
	},[props.windowSize])

	useEffect(() => {
		let totalSlides = Math.ceil((props.content.videoList.length)/(carouselSizeState.visibleSlides))
		setTotalSlideSegments(totalSlides)
		setCurrentSegment(Math.min(currentSegment, totalSlides-1));

	},[carouselSizeState])

	useEffect(() => {

		carouselProgressBar.current.style.width = Math.min(((currentSegment+1)/totalSlideSegments)*100,100)+"%";

	},[totalSlideSegments])


	useEffect(() => {

		carouselProgressBar.current.style.width = Math.min(((currentSegment+1)/totalSlideSegments)*100,100)+"%";

	},[currentSegment])

	function onBackClick(){
		setCurrentSegment(Math.max(currentSegment-1,0));
		trackingArrowLeft();
		
	}

	function onNextClick(){
		setCurrentSegment(Math.min(currentSegment+1,totalSlideSegments));
		trackingArrowRight();
	}

	function onTouchEnd(){

		let nextSegment = (carouselProviderRef.current.carouselStore.state.currentSlide/carouselSizeState.visibleSlides)
		setCurrentSegment(Math.ceil(nextSegment))
	}

	return (
		<div id={"sponsored_video"} className={classes.sponsored_video} >
		
			<div className={classes['sponsored_video__advertisement']}>ADVERTISEMENT</div>
				<div className={classes['sponsored_video__player-container']}>
					<div className={classes['sponsored_video__logo-wrapper']}>
					{/* <img className={classes['sponsored_video__logo--bbc']} src={getFileName(globalImages, globalJson.logos.storyworks)} alt="test"/> */}
						<ClientLogo globalImages={globalImages} />
					</div>
					<div className={`${classes['sponsored_video__video_container']} `}>
						{videoPlayerInfoMarkup}
						<div className={classes.sponsored_video__video_wrap}>
							<div className={`aspect-ratio-box`}>
                    			<div className={`aspect-ratio-box-inside`}>
									{videoPlayerMarkup}
								</div>
							</div>
							{shareVideoMarkupDesk}
						</div>
						{shareVideoMarkup}
					</div>
				</div>
			<div className={classes.sponsored_video__carousel_heading}>{props.content.heading}</div>
			<CarouselProvider
				ref={carouselProviderRef} 
				visibleSlides={carouselSizeState.visibleSlides}
				totalSlides={props.content.videoList.length} 
				naturalSlideWidth={carouselSizeState.naturalSlideWidth}
				step={carouselSizeState.visibleSlides}
				dragStep={carouselSizeState.visibleSlides}
        		naturalSlideHeight={carouselSizeState.naturalSlideHeight}
				dragEnabled={true}
				className={classes.pure_react_carousel}
				onTouchEnd={() => onTouchEnd()}
				onMouseUp={() => onTouchEnd()}
				>
				<div className={classes.pure_react_carousel__slider_wrap}>
					<Slider	className={classes.pure_react_carousel__slider}>
						{videoChoices}
					</Slider>

				
					<ButtonBack onClick={() => onBackClick()} className={classes.sponsored_video__carousel_progress_button_left}>
						
						<div className={classes.sponsored_video__carousel_arrow_cont}>
                        	<img className={`black_arrow_btn ${classes.sponsored_video__carousel_arrow_left}`} style={{transform: 'rotate(180deg)'}} src={getFileName(globalImages, 'arrow_right.svg')} alt={`arrow right`} />
                    	</div>
					</ButtonBack>
					<div className={classes.sponsored_video__carousel_progress_counter}>
						0{currentSegment+1}/0{totalSlideSegments}
					</div>
					<ButtonNext onClick={() => onNextClick()} className={classes.sponsored_video__carousel_progress_button_right}>
						
						<div className={classes.sponsored_video__carousel_arrow_cont}>
                        	<img className={`black_arrow_btn ${classes.sponsored_video__carousel_arrow_right}`} src={getFileName(globalImages, 'arrow_right.svg')} alt={`arrow right`} />
                    	</div>
					</ButtonNext>

					</div>

									
				<div className={classes.sponsored_video__carousel_progress_container}>
					<div ref={carouselProgressBar} className={classes.sponsored_video__carousel_progress_bar}></div>
				</div>
		
			</CarouselProvider>
		
		</div>
	)
}

export default SponsoredVideos;